import * as React from "react";
const SvgExpandIconClosed = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<path d="M14 5L8.17678 10.8232C8.07915 10.9209 7.92085 10.9209 7.82322 10.8232L2 5" stroke="#CCCCCC" strokeWidth={1.33} strokeLinecap="round" /></svg>;
export default SvgExpandIconClosed;